module.exports = __webpack_public_path__ + "img/250460827_2025_1-2.9ed73338.png";